// extracted by mini-css-extract-plugin
export default {"body":"AutoLogoutPopup_body__xF8ox","logoutButton":"AutoLogoutPopup_logoutButton__HR4xr","em":"AutoLogoutPopup_em__fqRYg"};